import numeral from 'numeral'

import { Text } from '@loadsmart/loadsmart-ui'

import { type LoadDimensions } from '../../domain/LoadDimensions'
import { Commodity } from './LoadSummary.styles'

type LoadSummaryCommodityProps = {
  commodity?: string
  dimensions: LoadDimensions
  weight: number
}

function getFormattedDimensions(length?: number, width?: number, height?: number): string {
  // Dimensions are optional (may return null or 0 from the API)
  // but we have to preserve order (LxWxH) still if any of them is missing.
  const formattedDimensions = []

  if (length) {
    formattedDimensions.push(`${length}' L`)
  }

  if (width) {
    formattedDimensions.push(`${width}' W`)
  }

  if (height) {
    formattedDimensions.push(`${height}' H`)
  }

  return formattedDimensions.join(' x ')
}

export function LoadSummaryCommodity({ commodity, dimensions, weight }: LoadSummaryCommodityProps) {
  const { length, width, height } = dimensions ?? {}
  const hasDimensions = Boolean(length || width || height)
  const formattedDimensions = hasDimensions && getFormattedDimensions(length, width, height)

  return (
    <Commodity>
      <Text as="div" variant="caption-bold" color="color-neutral-dark">
        Commodity
      </Text>
      <Text as="div" variant="body">
        {hasDimensions && <span>{formattedDimensions} / </span>}
        <span>{numeral(weight).format('0,0')} lbs</span>
        {commodity && <span> of {commodity}</span>}
      </Text>
    </Commodity>
  )
}
